import React, { useContext, useEffect, useState, useMemo, useRef } from 'react'
import { AuthSessionContext } from 'api/AuthSession'
import { Grid } from '@mui/material'
import { ArrowLeft } from 'react-bootstrap-icons'
import { Link, useNavigate } from 'react-router-dom'
import { LoadingSpinner } from 'components/LoadingSpinner'
import { TableReport } from 'components/TableReport'
import { Row } from 'react-bootstrap'
import format from 'date-fns/format'
import { Usertype } from 'utils/Constants'
import axios from 'api/axios-configure'
import SelectOneProductModalComponent from '../../Modals/SelectOneProductModalComponent'
import { StatementContext } from 'utils/context/StatementsContext'

const RunsForm = ({
    title
}
) => {
        const { getUserPermissionsSummary } = useContext(StatementContext)
        const isMounted = useRef(false)
        const navigate = useNavigate()
        const organizationId = localStorage.getItem('OrganizationId')
        const {IS_USER} = useContext(AuthSessionContext)
        const [isLoading, setIsLoading] = useState(true)
        const [pagination, setPagination] = useState({
            pageIndex: 0,
            pageSize: 25, //customize the default page size
        })

        const [columnVisibility, setColumnVisibility] = useState({
            runName: true,
            senderNumber: false
        })
            
        const [sorting, setSorting] = useState([])
        const [type] = useState(Usertype.SENDER)
        const [rowCount, setRowCount] = useState(0)
        const [tableData, setTableData] = useState([])
        const [isFetching] = useState(false)
        const [rowSelection, setRowSelection] = useState({})
        const [openModal, setOpenModal] = React.useState(false);

        const runColumns = useMemo(
            () => [
                {
                    accessorKey: 'createdDate',
                    id: 'createdDate',
                    header: 'Created Date',
                    enableHide: false,
                    minSize: 80,
                    size: 80,
                    Header: ({ column }) => (
                        <>
                            <div style={{height: 18 + 'px'}}>Created</div>
                            <div>Date</div>
                        </>
                    ),
                    Cell: (({cell}) => {
                        const dateString = cell.getValue()
                        const date = new Date(dateString)
                        const result = date.toLocaleString(date)
                        return (
                            <>
                                {result}
                            </>
                        )
                    }),
                },
                {
                    id: 'senderNumber',
                    size: 180,
                    maxSize: 180,
                    accessorKey: 'senderName',
                    header: 'Sender Name',
                    Header:({column}) => (
                        <>
                            <div style={{height: 18 + 'px'}}>Sender</div>
                            <div>Name</div>
                        </>
                    )
                },
                {
                    id: 'documentType',
                    accessorKey: 'documentType',
                    header: 'Document Type',
                    size: 140,
                    maxSize: 140,
                    Header:({column}) => (
                        <>
                            <div style={{height: 18 + 'px'}}>Document</div>
                            <div>Type</div>
                        </>
                    )
                },
                {
                    accessorKey: 'runName',
                    size: 60,
                    maxSize: 60,
                    header: 'Run Name',
                    Header: ({ column }) => (
                        <>
                            <div style={{height: 18 + 'px'}}>Run</div>
                            <div>Name</div>
                        </>
                    ),
                    minSize: 80
                },
                {
                    accessorKey: 'documentCount',
                    size: 60,
                    maxSize: 60,
                    header: 'numDocuments',
                    Header: ({ column }) => (
                        <>
                            <div style={{height: 18 + 'px'}}>Number of</div>
                            <div>Documents</div>
                        </>
                    ),
                },
                {
                    accessorKey: 'createdBy',
                    header: 'Created By',
                    size: 50,
                    grow: true,
                    Header: ({ column }) => (
                        <>
                            <div style={{height: 18 + 'px'}}>Created</div>
                            <div>By</div>
                        </>
                    ),
                },
                {
                    accessorKey: 'senderNumber',
                    header: 'Sender Number',
                    size: 50,
                    columnVisibility: false,
                    Header: ({column}) => (
                        <>
                            <div style={{height: 18 + 'px'}}>Sender</div>
                            <div>Number</div>
                        </>
                    )
                }      
            ],
            []
        )
        
        useEffect(() => {  
            getUserPermissionsSummary()      
        }, [])

        useEffect(() => {
            loadRunTableData()
        }, [pagination.pageIndex, pagination.pageSize, sorting])

        const closeModal = () => {
            setOpenModal(false)        
        }
        const loadRunTableData = (()=> {
            setIsLoading(true)
            
            axios
            .get(
                `/runs/${organizationId}`,
                {
                    params: {
                        pageNumber: pagination.pageIndex + 1,
                        pageSize: pagination.pageSize,
                        sortDesc: sorting[0]?.desc,
                        sortBy: sorting[0]?.id,
                    },
                }
            )
            .then((response) => {
                setTableData(response.data.items)
                setRowCount(response.data.totalCount)
                isMounted.current = true
            })
            .catch(err => {
                console.error(err)
            })
            .finally(() => {
                setIsLoading(false)
            })
        })        
        const allElementsSame = (arr) => {
            if (!arr || arr.length === 0) {
              return true; // An empty array or null can be considered to have all same elements
            }
            return arr.every(element => element === arr[0]);
        }

        const onViewDocumentsButtonClicked = (rows) => {
            const selectedRows = Object.keys(rows)
            const firstRowSplit = selectedRows[0].split(',')
            const senderNumber = firstRowSplit[3]
            const documentType = firstRowSplit[2]

            const productTypes = selectedRows.map(row => {
                const splitedKey = row.split(',')
                return splitedKey[2]
            });

            const isOneProductSelected = allElementsSame(productTypes)

            if (!isOneProductSelected)
            {
                setOpenModal(true)
                return false
            }

            const runData = selectedRows.map(row => {
                const splitedKey = row.split(',')
                return {
                    label: splitedKey[1],
                    value: splitedKey[0],
                }
            })

            const stateData = {senderNumber: {senderNumber}, documentType: {documentType}, runData: {runData}}
        
            // send over the list of row ids to the report and filter by these ids
            if (documentType === 'PB'){
                navigate(`/product-balancing/sender/report?senderNumber=${senderNumber}`, { state: stateData });
            }
            else if(documentType === 'PO'){
                navigate(`/payout/sender/report?senderNumber=${senderNumber}`, { state: stateData });
            }
            
            return true;
        }

        return (
            <>
                {(
                    <>
                        <div className="mx-2 form">
                        {
                            !isLoading ? (
                                <>
                                    <Grid container spacing={2} className="">
                                        <Grid item xs={12} style={{paddingTop: '0px'}}>
                                            <Link
                                                className="d-flex align-items-center"
                                                to="/dashboard">
                                                    <ArrowLeft size={13} />
                                                    <span className="ml-2"> Back</span>
                                            </Link>
                                        </Grid>
                                        <Grid item xs={12}>
                                            <h2>Runs</h2>
                                        </Grid>
                                        <Grid item xs={12}>
                                            <h4>List of current Runs imported into the data exchange</h4>
                                        </Grid>
                                    </Grid>
                                    <Row>
                                        {/*We might want to move this up, for now we will leave it on the table*/}
                                        <section className="statements-container mb-5">
                                            <div className="table-wrapper">
                                            <TableReport
                                                actionButtonLabel={'View Documents'}
                                                enableManualSorting={true}
                                                setColumnVisibility={setColumnVisibility}
                                                onPaginationChange={setPagination}
                                                pagination={pagination}
                                                sorting={sorting}
                                                onSortingChange={setSorting}
                                                enableRowSelection={true}
                                                enableHide={type === Usertype.SENDER && !IS_USER}
                                                rowCount={rowCount}
                                                columnVisibility={columnVisibility}
                                                columns={runColumns}
                                                tableData={tableData}
                                                onDownloadButtonClicked={
                                                    onViewDocumentsButtonClicked
                                                }
                                                onActionButtonClicked={
                                                    onViewDocumentsButtonClicked
                                                }
                                                rowId={(row) => { 
                                                    if(tableData.length > 0)
                                                        return (row.runId ?? '') + ',' + (row.runName ?? '') + ',' + (row.documentType ?? '') + ',' + (row.senderNumber ?? '')
                                                }}
                                                setRowSelection={setRowSelection}
                                                rowSelection={rowSelection}
                                                isLoading={isLoading}
                                                isFetching={isFetching}
                                                enableSelectAll={true}
                                            />
                                    </div>
                                </section>
                            </Row>
                                    </>
                            ) : (
                                <Grid container spacing={2} className="">
                                    <Grid item xs={12}>
                                        <LoadingSpinner/>
                                    </Grid>
                                </Grid>
                            )
                        }                                
                        </div>
                        <SelectOneProductModalComponent
                          showModal={openModal} 
                          closeModal={closeModal}                          
                        />
                    </>
                )}
            </>
        )
}

export default RunsForm